import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBU } from './BUContext';

const BUSelectorScreen = () => {
  const navigate = useNavigate();
  const { setCurrentBU } = useBU();

  const choose = (bu) => {
    setCurrentBU(bu);
    navigate('/dashboard', { replace: true });
  };

  return (
    <div
      data-testid="bu-selector-screen"
      className="min-h-screen bg-slate-950 flex flex-col items-center justify-center p-6"
    >
      <div className="mb-12 text-center">
        <h1 className="text-3xl font-semibold text-white tracking-tight">Cipher</h1>
        <p className="text-sm text-slate-500 mt-1">Choose your workspace</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-3xl">
        <button
          data-testid="bu-card-affiliate"
          onClick={() => choose('AFFILIATE')}
          className="group bg-slate-900/60 hover:bg-slate-900 border border-slate-800 hover:border-emerald-500/60 rounded-2xl p-8 text-left transition-all hover:-translate-y-0.5"
        >
          <p className="text-xs uppercase tracking-[0.22em] text-slate-500">Business Unit</p>
          <h2 className="text-white text-2xl font-semibold mt-3">AFFILIATE</h2>
          <p className="text-slate-400 text-sm mt-1">Performance Marketing</p>
          <div className="mt-8 text-xs text-slate-500 group-hover:text-emerald-400 transition-colors">
            Enter workspace →
          </div>
        </button>

        <button
          data-testid="bu-card-abh"
          onClick={() => choose('ABH')}
          className="group bg-slate-900/60 hover:bg-slate-900 border border-slate-800 hover:border-emerald-500/60 rounded-2xl p-8 text-left transition-all hover:-translate-y-0.5"
        >
          <p className="text-xs uppercase tracking-[0.22em] text-slate-500">Business Unit</p>
          <h2 className="text-white text-2xl font-semibold mt-3">ABH</h2>
          <p className="text-slate-400 text-sm mt-1">AfterBody Health</p>
          <div className="mt-8 text-xs text-slate-500 group-hover:text-emerald-400 transition-colors">
            Enter workspace →
          </div>
        </button>
      </div>
    </div>
  );
};

export default BUSelectorScreen;
